import React from "react";

export const Home: React.FC = () => {
    return (
        <div>
            <h1>Welcome to Algorythms Software</h1>
            <p>We are a software development company specializing in custom solutions for businesses of all sizes. Our team of experienced developers is dedicated to delivering high-quality software that meets the unique needs of our clients.</p>
            <p>Whether you need a simple web application or a complex enterprise solution, we have the expertise to get the job done. Contact us today to learn more about how we can help your business succeed with custom software development.</p>
        </div>);
};

export default Home;
